import { useAnalytics } from 'app/context/Analytics';
import { PosthogEventName } from 'app/copied/constants/PosthogEventName';
import { motion } from 'framer-motion';
import { useTailorIsOpen } from 'app/hooks/useTailorIsOpen';

const HalfOpenOverlay = () => {
  const { setIsOpen } = useTailorIsOpen();
  const { captureEventWithActiveScreen } = useAnalytics();

  const handleClick = () => {
    setIsOpen(false);
    captureEventWithActiveScreen(PosthogEventName.Minimized, { halfautoOpen: true });
  };

  return (
    <motion.div
      onClick={handleClick}
      className="inset-0 bg-black bg-opacity-30 fixed z-[-1]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, delay: 0.5 }}
    />
  );
};

export default HalfOpenOverlay;
